import {normalizeActivity} from "./normalized-activity";
import {checkpointEvidenceIds} from "./interactive-activity-checkpoints";
import {hasProduction} from "./attendance-results";
import type {ActivityVersion, StudentAttempt} from "./activity-library";

export function trackingDetails(version: ActivityVersion, attempt: StudentAttempt) {
  const inputs = normalizeActivity(version).blocks.filter(b => ["question", "measurement_table", "graph_task"].includes(b.type));
  const filled = (id: string) => hasProduction({...attempt, answers: {[id]: attempt.answers[id] ?? ""},
    photos: {[id]: attempt.photos?.[id] ?? []}, evidence: [], helpUsage: {}});
  const initialIds = new Set(inputs.flatMap(b => b.type === "question" && b.helpSnapshotSourceBlockId ? [b.helpSnapshotSourceBlockId] : []));
  const productions = inputs.filter(b => !initialIds.has(b.id)).map(b => {
    const ids = b.type === "question" && b.helpSnapshotSourceBlockId ? [b.helpSnapshotSourceBlockId, b.id] : [b.id];
    return {id: b.id, title: b.title || ("prompt" in b ? b.prompt : b.id), completed: ids.every(filled),
      blocks: ids.map(id => ({id, filled: filled(id), answer: attempt.answers[id] ?? ""}))};
  });
  const checkpoints = version.checkpoints.map(cp => {
    const evidence = checkpointEvidenceIds(cp).map(id => ({id, available: filled(id)}));
    return {id: cp.id, code: cp.competenceCode, evidence, reached: evidence.length > 0 && evidence.every(e => e.available)};
  });
  const activityDates = [attempt.startedAt, attempt.lastSavedAt,
    ...Object.values(attempt.helpUsage ?? {}).map(h => h.helpOpenedAt),
    ...Object.values(attempt.photos ?? {}).flat().map(p => p.createdAt),
    ...(attempt.focusGuard?.events ?? []).map(e => e.at)].filter((at): at is string => !!at);
  return {productions, checkpoints, completed: productions.filter(p => p.completed).length,
    lastActivityAt: activityDates.sort((a,b) => Date.parse(b) - Date.parse(a))[0],
    expected: productions.length, photos: Object.values(attempt.photos ?? {}).flat(),
    help: Object.entries(attempt.helpUsage ?? {}).filter(([,h]) => h.helpUsed)};
}
